import { AttachmentType } from 'common/components/ScheduleSendReport/types/attachment';
import { BaseScreenshotSubscriptionParameters, SubscriptionResponse } from './ScreenshotSubscriptionsAPI';
import { fetchWithDefaultHeaders } from 'common/http';
import { WeekTypes } from 'common/types/frequencySelector/frequencySelector';

export const createScheduleDelivery = (payload: ScheduleDeliverySubscription): SubscriptionResponse => {
  return fetchWithDefaultHeaders('/api/notifications_and_alerts/screenshot_subscriptions', {
    method: 'POST',
    body: JSON.stringify({ subscription: payload }),
  });
};

export function updateScheduleDelivery(payload: ScheduleDeliverySubscription): SubscriptionResponse {
  return fetchWithDefaultHeaders(
    `/api/notifications_and_alerts/screenshot_subscriptions/${payload.asset_uid}`,
    {
      method: 'PUT',
      body: JSON.stringify({ subscription: payload }),
    },
  );
}

export interface ScheduleDeliverySubscription extends BaseScreenshotSubscriptionParameters {
  subscriber_uid: string[] | string;
  recurrence: Recurrence;
  attachments: Attachment[];
  last_occurrence?: string | null;
  schedule_name: string;
  subject_line: string;
}

export type Attachment = {
  component_uid?: string;
  type: AttachmentType;
  format?: string;
  pdf_options?: Record<string, unknown> | undefined;
};

export interface Recurrence {
  type: string;
  interval: number;
  days?: number[];
  repeat_on?: WeekTypes;
}
